export function arrayRemove(arr, obj) {
  const index = arr.indexOf(obj);
  if (index >= 0) {
    arr.splice(index, 1);
  }
}
// 这个比lodash的快
export function cloneFast(obj) {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (error) {
    console.warn(error);
    return {};
  }
}
const readOnlyProxyCache = new WeakMap();
const readOnlyProxyHandler = {
  get(target, key) {
    const value = Reflect.get(target, key);
    return createReadOnlyProxy(value);
  },
  set() {
    return true;
  },
  deleteProperty() {
    return true;
  },
  defineProperty() {
    return true;
  },
  preventExtensions() {
    return false;
  }
};
export function createReadOnlyProxy(target) {
  if (typeof target !== 'object' || target === null) return target;
  let readOnlyProxy = readOnlyProxyCache.get(target);
  if (!readOnlyProxy) {
    readOnlyProxy = new Proxy(target, readOnlyProxyHandler);
    readOnlyProxyCache.set(target, readOnlyProxy);
  }
  return readOnlyProxy;
}
//# sourceMappingURL=lang.js.map
